onComplete(function() {
	// Kopie op verzoek: in de formulierbouwer staat direct na het vinkje een verborgen veld
	// "E-mailadres (voor versturen kopie)". Dat veld krijgt alleen het ingevulde e-mailadres
	// zolang het vinkje aan staat; leeg verstuurt het CMS geen kopie.
	document.querySelectorAll('[data-partial="form"] form').forEach(function(form) {
		form.querySelectorAll('.form-group').forEach(function(group) {
			var checkbox = group.querySelector('input[type="checkbox"]');
			var copyGroup = group.nextElementSibling;
			var copyInput = copyGroup && copyGroup.querySelector('input[type="email"]');
			if (!checkbox || !copyInput) {
				return;
			}

			var emailInput = Array.prototype.find.call(
				form.querySelectorAll('input[type="email"]'),
				function(input) { return input !== copyInput; }
			);
			if (!emailInput) {
				return;
			}

			copyGroup.classList.add('form-copy-address');
			var sync = function() {
				copyInput.value = checkbox.checked ? emailInput.value : '';
			};
			checkbox.addEventListener('change', sync);
			emailInput.addEventListener('input', sync);
			form.addEventListener('submit', sync, true);
			sync();
		});
	});
});
